import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    Platform,
    Linking,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import InvoiceDetails from "./InvoiceDetails";
import ReturnsDetails from "./RetrurnsDetails";
import DateTimePicker from 'react-native-modal-datetime-picker';
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let isMobile = false;
let scale = 1;
const InfoIcon = require("../images/StatementOfAccount/InfoIcon.png");
const imgCalender = require("../images/StatementOfAccount/calender.png");
const CloseIcon = require("../images/InvoiceDetails/closeIcon.png");
const imgDownloadIcon = require("../images/InvoiceDetails/downloadIcon.png");
const wFactor = 0.75; //width factor
const widths = [173 * wFactor, 230 * wFactor, 200 * wFactor, 140 * wFactor, 140 * wFactor, 180 * wFactor, 200 * wFactor];

class StatementOfAccount extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showStatementOfAccount: false,
            showInvoiceDetails: false,
            selectedFromDate: '',
            selectedToDate: '',
            fromDateStyle: AppStyles.dateTextStyle2,
            toDateStyle: AppStyles.dateTextStyle2,
            soaID: '',
            soaDate: '',
            soaTotalDebit: '',
            soaTotalCredit: '',
            soaBalance: '',
            soaTransactions: [],
            ID: '',
            Date: '',
            Amount: '',
            Details: [],
            soaData: [],
            isOther: false,
            showFromDatePicker: false,
            showToDatePicker: false,

        };
    }
    Pressables = {};

    async componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        loaderHandler.showLoader(STRINGS.loading, this);
        let resp = await ServerOperations.getSOA(this.state.selectedFromDate, this.state.selectedToDate);

        this.setState({
            selectedFromDate: resp.FROM_DATE,
            selectedToDate: resp.TO_DATE,
            soaTransactions: resp.DETAILS,
            soaTotalDebit: resp.TOTAL_DEBIT,
            soaTotalCredit: resp.TOTAL_CREDIT,
            soaBalance: resp.TOTAL_BALANCE,
            soaURL: resp.URL,
            soaData: resp,
            showRetDetails: false,
        });
        loaderHandler.hideLoader();
    }

    getSOAData = (soaDetails) => {
        return soaDetails.map((item) => {
            return (
                <TouchableOpacity
                    style={{
                        flexDirection: 'row',
                        marginTop: 20, height: 50, borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                        borderBottomWidth: 1.5, justifyContent: 'flex-start',
                        marginRight: -5
                    }}
                    onPress={() => {
                        if (item.TYPE == 'INVOICE' || item.TYPE == 'RETURNS') {

                            loaderHandler.showLoader(STRINGS.loading, this);
                            this.renderInvoiceReturnsData(item.VOUCHER, item.DATE, item.VALUE, item.TYPE);
                        }
                    }}
                >
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[0] * scale, fontSize: 16 * scale }]}>{item.DATE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[1] * scale, fontSize: 16 * scale }]}>{item.TYPE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[2] * scale, fontSize: 16 * scale }]}>{item.VOUCHER}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[3] * scale, fontSize: 16 * scale }]}>{item.DEBIT}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[4] * scale, fontSize: 16 * scale }]}>{item.CREDIT}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[5] * scale, fontSize: 16 * scale }]}>{item.BALANCE}</Text>
                    <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[6] * scale, fontSize: 16 * scale }]}>{item.DESC}</Text>
                </TouchableOpacity>
            )
        });
    }


    renderHeaderInvoiceDetails = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between", height: 75, width }}>
                <TouchableOpacity>
                    {/* <Image source={CloseIcon} style={{width: 14, height: 14}} /> */}
                </TouchableOpacity>
                <TouchableOpacity onPress={() => {
                    this.setState({ showInvoiceDetails: false })
                }}
                    style={{ marginRight: 16 }}>
                    <Image source={CloseIcon} style={{ width: 14, height: 14 }} />
                </TouchableOpacity>
            </View>
        )
    }


    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between", }}>
                {/* <TouchableOpacity onPress={() => window.history.back()}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity> */}
                <View></View>
                <Text style={[AppStyles.H2Styles]}>{STRINGS.Statement_Account}</Text>
                <View></View>
                {/* <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity> */}
            </View>
        )
    }

    renderInvoiceDownloadButton = () => {
        return (
            <TouchableOpacity style={{
                display: 'flex', width: 53, height: 56, justifyContent: 'center', alignItems: 'center', borderRadius: 50,
                backgroundColor: '#92D8F5', boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)', position: 'absolute', bottom: 20, right: 20,

            }} onPress={() => Linking.openURL(this.state.invoiceURL)}>
                <Image source={imgDownloadIcon} style={{ width: 56, height: 56, marginTop: 4 }} />
            </TouchableOpacity>
        )
    }

    renderDownloadButton = () => {
        return (
            <TouchableOpacity style={{
                display: 'flex', width: 53, height: 56, justifyContent: 'center', alignItems: 'center', borderRadius: 50,
                backgroundColor: '#92D8F5', boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.15)', position: 'absolute', bottom: 85, right: 20,
            }} onPress={() => Linking.openURL(this.state.soaURL)} >
                <Image source={imgDownloadIcon} style={{ width: 56, height: 56, marginTop: 4 }} />
            </TouchableOpacity>
        )
    }



    renderMobile() {
        scale = width / 420;
        var paddLeft = 20;
        if (this.state.showInvoiceDetails == true) { paddLeft = undefined }
        return (
            <View style={styles.container}>
                {this.state.showInvoiceDetails == false && this.renderHeaderMobile()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, paddingHorizontal: paddLeft, }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.state.showInvoiceDetails == false && this.renderPart1Mobile()}
                        {this.state.showStatementOfAccount == true && !this.state.showInvoiceDetails && this.renderPart2Mobile()}
                        {this.state.showStatementOfAccount == true && !this.state.showInvoiceDetails && this.renderPart3Mobile()}
                        {this.state.showStatementOfAccount == true && !this.state.showInvoiceDetails && this.renderPart4Mobile()}
                        {/* {this.state.showInvoiceDetails == true && this.InvoiceDetails()} */}
                        {this.state.showInvoiceDetails &&
                            <InvoiceDetails
                                InvoiceNumber={this.state.ID}
                                InvoiceDate={this.state.Date}
                                InvoiceAmount={this.state.Amount}
                                self={this}
                                showInvoiceDetails={(show) => { this.setState({ showInvoiceDetails: show, }) }} />
                        }
                    </View>
                </ScrollView>
                {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE')}
                {this.state.showStatementOfAccount && !this.state.showInvoiceDetails && this.renderDownloadButton()}
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showFromDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedFromDate: Commons.formatDateLocal(date), showFromDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showFromDatePicker: false })}
                />
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showToDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedToDate: Commons.formatDateLocal(date), showToDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showToDatePicker: false })}
                />
            </View >
        );
    }

    render() {

        width = Dimensions.get("window").width;
        height = Dimensions.get("window").height;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();

            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });

            return this.renderMobile();
        }

        if (!this.props.self) {
            window.location = './ClientHomePage?tab=' + STRINGS.Statement_of_Account_Desktop;
            return;
        } else {
            this.props.self.currentComponent = this;
        }

        width = Commons.getDesktopWidth();
        height = Commons.getDesktopHeight();
        marginTop = 300;
        scale = width / 1126;
        if (scale > 1) scale = 1;
        styles = this.styles();
        const soaHeaders = [
            { title: STRINGS.Date_desktop, width: widths[0] * scale },
            { title: STRINGS.Transaction_Type, width: widths[1] * scale },
            { title: STRINGS.Transaction_No, width: widths[2] * scale },
            { title: STRINGS.Debit, width: widths[3] * scale },
            { title: STRINGS.Credit, width: widths[4] * scale },
            { title: STRINGS.Balance, width: widths[5] * scale },
            { title: STRINGS.Notes, width: widths[6] * scale },

        ];
        return (
            <View style={styles.container}>
                <View style={{
                    flex: 1, flexDirection: 'row', gap: 20,
                    backgroundColor: AppStyles.desktopBackgroundColor, height: '100%', width: '100%'
                }}>
                    {this.state.showInvoiceDetails == false && (
                        <View style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                            backgroundColor: AppStyles.desktopBackgroundColor, height, width
                        }}>
                            <Text style={[AppStyles.H2Styles, { marginLeft: 50, marginTop: 80 }]}>{STRINGS.Statement_of_Account_Desktop}</Text>
                            <View style={{ flexDirection: 'row', gap: 10, marginHorizontal: 50, marginTop: 32 }}>
                                {this.renderDateSelection()}
                                {this.renderRequestButton()}
                                {this.state.flag == 1 && this.renderDownloadButtonDesktop()}
                            </View>
                            {this.state.flag == 1 && (
                                <View style={{
                                    paddingHorizontal: 40, marginTop: 20, backgroundColor: 'white',
                                    borderRadius: 16, paddingBottom: 20,
                                    marginLeft: 50,
                                    marginTop: 50
                                }}>
                                    <View style={{
                                        display: 'flex', borderTopRightRadius: 16, borderTopLeftRadius: 16,
                                        paddingVertical: 20, flexDirection: 'row', justifyContent: 'flex-start',
                                        borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                                        borderBottomWidth: 1.5,
                                    }}>
                                        {soaHeaders.map((header) => {

                                            return (
                                                <Text style={[AppStyles.tblHeaderStyle,
                                                { fontSize: 18 * scale, width: header.width }]}>{header.title}</Text>
                                            )
                                        })}
                                    </View>
                                    <ScrollView style={{ height: height - 350, }} showsVerticalScrollIndicator={true}>
                                        {this.getSOAData(this.state.soaData.DETAILS)}
                                    </ScrollView>
                                </View>
                            )}

                        </View>
                    )}

                    {this.state.showInvoiceDetails && (
                        <InvoiceDetails
                            InvoiceNumber={this.state.ID}
                            InvoiceDate={this.state.Date}
                            InvoiceAmount={this.state.Amount}
                            showInvoiceDetails={(show) => { this.setState({ showInvoiceDetails: show }); this.props.self.setState({ style: { opacity: 1 } }); }}
                        />
                    )}

                    {this.state.showRetDetails && (
                        <ReturnsDetails
                            ReturnsNumber={this.state.ID}
                            ReturnsDate={this.state.Date}
                            ReturnsAmount={this.state.Amount}
                            showRetDetails={(show) => { this.setState({ showRetDetails: show }); this.props.self.setState({ style: { opacity: 1 } }); }}
                        />
                    )}

                </View>
            </View >
        );
    }



    renderDateSelection = () => {
        return (
            <View style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 7, flexDirection: 'row' }}>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.fromDateInput.showPicker();
                        } else {
                            this.setState({ showFromDatePicker: true });
                        }
                    }}
                    style={{
                        display: 'flex', height: 42, flexDirection: 'row', width: 265, justifyContent: 'space-between',
                        alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)'
                    }}>
                    <Text style={[AppStyles.FromToDateTextStyle, {
                        position: 'absolute', top: -10, left: 10,
                        backgroundColor: AppStyles.desktopBackgroundColor, width: 35
                    }]}>{STRINGS.from}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.fromDateInput = e}
                            type="date"
                            value={this.state.selectedFromDate}
                            onChange={(e) => this.setState({ selectedFromDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                        />
                    )}
                </TouchableOpacity>

                <TouchableOpacity
                    onPress={() => {
                        if (Platform.OS === 'web') {
                            this.toDateInput.showPicker();
                        } else {
                            this.setState({ showToDatePicker: true });
                        }
                    }}
                    style={{ display: 'flex', height: 42, flexDirection: 'row', width: 265, justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)' }}>
                    <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: AppStyles.desktopBackgroundColor, width: 20 }]}>{STRINGS.to}</Text>
                    <Text style={[AppStyles.dateTextStyle2, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                    <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                    {Platform.OS === 'web' && (
                        <input
                            ref={e => this.toDateInput = e}
                            type="date"
                            value={this.state.selectedToDate}
                            onChange={(e) => this.setState({ selectedToDate: e.target.value, })}
                            style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                        />
                    )}
                </TouchableOpacity>

                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showFromDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedFromDate: Commons.formatDateLocal(date), showFromDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showFromDatePicker: false })}
                />
                <DateTimePicker
                    mode="date"
                    isVisible={this.state.showToDatePicker}
                    onConfirm={(date) => {
                        this.setState({ selectedToDate: Commons.formatDateLocal(date), showToDatePicker: false });
                    }}
                    onCancel={() => this.setState({ showToDatePicker: false })}
                />
            </View>
        )
    }

    renderRequestButton = () => {
        return (
            <TouchableOpacity style={[AppStyles.primaryButtonStyle, { width: 109 }]}
                onPress={async () => {
                    loaderHandler.showLoader(STRINGS.loading, this.props.self);
                    setTimeout(async () => {
                        await this.loadData();
                        this.setState({ flag: 1 });
                        loaderHandler.hideLoader();
                    }, 600);
                }}>
                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
            </TouchableOpacity>
        )
    }
    renderDownloadButtonDesktop = () => {
        return (
            <TouchableOpacity style={[AppStyles.secondaryButtonStyle, { width: 109 }]}
                onPress={() => Linking.openURL(this.state.soaURL)}>
                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Download_Button}</Text>
            </TouchableOpacity>
        )
    }

    renderPart1 = () => {
    }


    renderPart1Mobile = () => {
        return (
            <View style={{ width: width - 40, marginTop: 30, flexDirection: 'column', gap: 30 }}>
                <View style={{ display: 'flex', width: width - 40, justifyContent: 'center', alignItems: 'center', gap: 7, flexDirection: 'row' }}>

                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                this.fromDateInput.showPicker();
                            } else {
                                this.setState({ showFromDatePicker: true });
                            }
                        }}
                        style={{
                            display: 'flex', height: 40, flexDirection: 'row', width: '48%', justifyContent: 'space-between',
                            alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)', backgroundColor: '#FFF'
                        }}>
                        <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: 'white', width: 35 }]}>{STRINGS.from}</Text>
                        <Text style={[this.state.fromDateStyle, { paddingHorizontal: 10 }]}>{this.state.selectedFromDate}</Text>
                        <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                        {Platform.OS === 'web' && (
                            <input
                                ref={e => this.fromDateInput = e}
                                type="date"
                                value={this.state.selectedFromDate}
                                onChange={(e) => this.setState({ selectedFromDate: e.target.value, fromDateStyle: AppStyles.dateTextStyle2, showStatementOfAccount: false })}
                                style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}

                            />
                        )}
                    </TouchableOpacity>

                    <TouchableOpacity
                        onPress={() => {
                            if (Platform.OS === 'web') {
                                this.toDateInput.showPicker();
                            } else {
                                this.setState({ showToDatePicker: true });
                            }
                        }}
                        style={{ display: 'flex', height: 40, flexDirection: 'row', width: '48%', justifyContent: 'space-between', alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: 'rgba(59, 98, 127, 0.50)', backgroundColor: '#FFF' }}>
                        <Text style={[AppStyles.FromToDateTextStyle, { position: 'absolute', top: -10, left: 10, backgroundColor: 'white', width: 20 }]}>{STRINGS.to}</Text>
                        <Text style={[this.state.toDateStyle, { paddingHorizontal: 10 }]}>{this.state.selectedToDate}</Text>
                        <Image source={imgCalender} style={{ width: 17, height: 17, marginRight: 10 }} />
                        {Platform.OS === 'web' && (
                            <input
                                ref={e => this.toDateInput = e}
                                type="date"
                                value={this.state.selectedToDate}
                                onChange={(e) => this.setState({ selectedToDate: e.target.value, showStatementOfAccount: false })}
                                style={{ position: 'absolute', top: 0, left: 0, opacity: 0, width: '100%', height: '100%' }}
                            />
                        )}
                    </TouchableOpacity>
                </View>

                {this.state.showStatementOfAccount == false && (
                    <TouchableOpacity style={[AppStyles.loginButtonStyles, {}]}
                        onPress={async () => {
                            loaderHandler.showLoader(STRINGS.loading, this);
                            setTimeout(async () => {
                                await this.loadData();
                                loaderHandler.hideLoader();
                            }, 600);
                            this.setState({ showStatementOfAccount: true })
                        }}>
                        <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.Request}</Text>
                    </TouchableOpacity>
                )}
            </View>
        )
    }

    renderPart2 = () => {

    }

    renderPart2Mobile = () => {
        return (
            <View style={[AppStyles.AccountStatementStyle, { width: width - 40, marginTop: 48, paddingBottom: 16, paddingHorizontal: 20 }]}>
                <View style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 16, alignSelf: 'stretch' }}>
                    <View style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: 16, justifyContent: 'center', alignItems: 'center', alignSelf: 'stretch' }}>
                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{STRINGS.Balance}</Text>
                        <Text style={[AppStyles.DueBalanceNumStyle, { paddingHorizontal: 32 }]}>
                            {this.state.soaBalance}
                            <Text style={[AppStyles.DueBalanceTextStyle, {}]}>
                                JOD
                            </Text>
                        </Text>
                    </View>
                    <View style={{ flexDirection: 'row', gap: 8, width: width - 40, paddingHorizontal: 20 }}>
                        <View style={[AppStyles.TotalDebitCreditStyle, { width: '49%' }]}>
                            <Text style={[AppStyles.ButtonTextStyles, { textAlign: 'center' }]}>{STRINGS.Total_Debit}</Text>
                            <Text style={[AppStyles.BodyTextStyles, { textAlign: 'center' }]}>{this.state.soaTotalDebit}</Text>
                        </View>

                        <View style={[AppStyles.TotalDebitCreditStyle, { width: '48%' }]}>
                            <Text style={[AppStyles.ButtonTextStyles, { textAlign: 'center' }]}>{STRINGS.Total_Credit}</Text>
                            <Text style={[AppStyles.BodyTextStyles, { textAlign: 'center' }]}>{this.state.soaTotalCredit}</Text>
                        </View>
                    </View>
                </View>

            </View>
        );
    }

    renderPart3 = () => {

    }

    renderInvoiceReturnsData = async (ID, Date, Amount, Type) => {
        this.setState({ ID: ID, Date: Date, Amount: Amount });
        this.props.self.setState({ style: { opacity: 0.3 } });
        if (Type == 'INVOICE') {
            this.setState({ showInvoiceDetails: true });
        } else {
            this.setState({ showInvoiceDetails: true });
        }
        loaderHandler.hideLoader();
    }

    renderInvoiceReturnsDataMobile = async (ID, Date, Amount, Type) => {
        this.setState({ ID: ID, Date: Date, Amount: Amount });
        if (Type == 'INVOICE') {
            this.setState({ showInvoiceDetails: true });
        } else {
            this.setState({ showInvoiceDetails: true });
        }
    }

    renderPart3Mobile = () => {
        const TransactionsItem = this.state.soaTransactions.map((item) =>
            <TouchableOpacity style={[AppStyles.TransactionsStyle, { width: width - 40, paddingHorizontal: 1 }]}
                onPress={() => {
                    if (item.TYPE == 'INVOICE' || item.TYPE == 'RETURNS') {

                        loaderHandler.showLoader(STRINGS.loading, this);
                        this.renderInvoiceReturnsDataMobile(item.VOUCHER, item.DATE, item.VALUE, item.TYPE);
                        loaderHandler.hideLoader();
                        // this.setState({ showInvoiceDetails: true });
                    }
                }}>
                <View style={{ paddingHorizontal: 20, paddingVertical: 10, flexDirection: 'row', justifyContent: 'space-between', alignSelf: 'stretch' }}>
                    <View style={{ gap: 8, alignSelf: 'stretch', width: width - 180 }}>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.40)' }, !item.VOUCHER.trim() && { display: 'none' }]}>{item.VOUCHER}</Text>
                        <Text style={[AppStyles.ButtonTextStyles]}>{item.TYPE}</Text>
                        <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(20, 36, 46, 0.60)', textAlign: 'left' }, !item.DESC.trim() && { display: 'none' }]}>{item.DESC}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { color: 'rgba(20, 36, 46, 0.60)' }]}>{item.DATE}</Text>
                    </View>
                    <View style={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Text style={[AppStyles.H3Styles, { textAlign: 'center' }]}>{item.VALUE}</Text>
                        <Text style={[AppStyles.SecondaryTextStyles, { textAlign: 'center', color: 'rgba(0, 0, 0, 0.50)' }]}>Balance: {item.BALANCE}</Text>
                    </View>
                </View>
                {(item.TYPE == 'INVOICE' || item.TYPE == 'RETURNS') &&
                    <View style={{ position: 'absolute', right: 23, top: 12, opacity: 0.6, }}>
                        <Image source={InfoIcon} style={{ width: 15, height: 15 }}></Image>
                    </View>
                }
            </TouchableOpacity>
        );
        return (
            <View style={{ width: width - 40, marginTop: 32, flexDirection: 'column', gap: 14 }}>
                <Text style={[AppStyles.H3Styles, { width: width - 40 }]}>{STRINGS.Transaction}</Text>
                {TransactionsItem}
            </View>
        )
    }

    renderPart4 = () => {

    }

    renderPart4Mobile = () => {
        return (
            <View style={{ height: 100 }}>

            </View>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default StatementOfAccount;
